
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"125","height":"120"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 2212"}},[_c('path',{attrs:{"data-name":"Rectangle 2934","fill":"none","d":"M0 0h124.999v120H0z"}}),_c('path',{attrs:{"data-name":"Path 1337","d":"M93.999 45.496a6 6 0 00-6 6V65.77L77.878 55.649a5.977 5.977 0 00-4.48-2.02H61.753L45.609 37.485a5.979 5.979 0 00-4.481-2.02h-15.91a5.993 5.993 0 00-3.98 10.48l7.683 7.684h-3.7a5.994 5.994 0 00-3.98 10.481l8.6 8.6H12.499V26.5a6.255 6.255 0 10-12.5-.5v68a5.983 5.983 0 002.019 4.481L23.538 120h101.46V74.035L98.48 47.517a5.983 5.983 0 00-4.481-2.021z","fill":"#ec4618"}}),_c('g',{attrs:{"data-name":"Group 2211"}},[_c('g',{attrs:{"data-name":"Group 2210","fill":"#f9a36c"}},[_c('path',{attrs:{"data-name":"Path 1338","d":"M93.999 45.496a6 6 0 00-6 6v21.221h-76V26a6 6 0 10-12 0v68a6 6 0 1012 0v-9.283h76v9.285a6 6 0 0012 0v-42.5a6 6 0 00-6-6.006z"}}),_c('path',{attrs:{"data-name":"Path 1339","d":"M25.218 65.629h48.18a6 6 0 000-12h-48.18a6 6 0 000 12z"}}),_c('path',{attrs:{"data-name":"Path 1340","d":"M25.218 47.465h15.91a6 6 0 000-12h-15.91a6 6 0 100 12z"}})])])])])
          )
        }
      }
    